export function deepClone<T = unknown>(obj: T): T {
	return JSON.parse(JSON.stringify(obj));
}
